module.exports = __webpack_public_path__ + "img/enterprise-network-solutionsimg-4.4c9cd57e.png";